<script>
    import { onMount } from "svelte";
    import EpisodeCard from "./EpisodeCard.svelte";
    import {
        episodes,
        page,
        filter_string,
        pagination_size,
    } from "../stores/store.js";
    import { slide } from "svelte/transition";

    $: toggle_string = $pagination_size === 8 ? "Όλα τα επεισόδια" : "Ανά 8";
    $: listing_episodes = filterEpisodes($filter_string);
    $: page_count = Math.ceil(listing_episodes.length / $pagination_size);
    $: currently_shown = listing_episodes.slice(
        $page * $pagination_size,
        $page * $pagination_size + $pagination_size,
    );

    function nextPage() {
        $page += 1;
    }

    function prevPage() {
        $page -= 1;
    }

    function setPage(id) {
        $page = id;
    }

    function formatName(name) {
        return name.split(":").slice(1).join(":");
    }

    function filterEpisodes(filter) {
        if (filter) {
            $page = 0;
            let lower = filter.toLowerCase();
            return $episodes.filter(
                (e) =>
                    e.title.toLowerCase().search(lower) !== -1 ||
                    e.tags.some(
                        (tag) => tag.toLowerCase().search(lower) !== -1,
                    ),
            );
        } else {
            return $episodes;
        }
    }

    function togglePages() {
        if ($pagination_size === 8) {
            $page = 0;
            $pagination_size = 500;
        } else {
            $page = 0;
            $pagination_size = 8;
        }
    }

    const delta = 2; // how many pages to show around current page

    function visiblePages(current, total) {
        let pages = [];

        const start = Math.max(0, current - delta);
        const end = Math.min(total - 1, current + delta);

        // Always include first page
        if (start > 0) {
            pages.push(0);
            if (start > 1) pages.push("dots-left");
        }

        // Middle pages
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        // Always include last page
        if (end < total - 1) {
            if (end < total - 2) pages.push("dots-right");
            pages.push(total - 1);
        }

        return pages;
    }

    onMount(() => filterEpisodes($filter_string));
</script>

<div class="p-2" transition:slide>
    <h2 class="text-fuchsia-400 capitalize text-3xl mb-4">Episodes</h2>

    <div class="flex justify-between flex-wrap gap-1">
        <div class="btn-group order-2 flex gap-0 md:order-1">
            <button
                class="btn opacity-70 btn-neutral border-0 opacity-70 ml-0"
                class:btn-disabled={$page === 0}
                on:click={prevPage}>«</button
            >
            {#each visiblePages($page, page_count) as page_id}
                {#if page_id === "dots-left" || page_id === "dots-right"}
                    <button class="btn btn-disabled opacity-50 select-none"
                        >…</button
                    >
                {:else}
                    <button
                        class="btn opacity-70 btn-neutral border-0 ml-0"
                        class:!bg-fuchsia-400={$page === page_id}
                        class:!opacity-100={$page === page_id}
                        on:click={() => setPage(page_id)}
                    >
                        {page_id + 1}
                    </button>
                {/if}
            {/each}
            <button
                class="btn btn-neutral opacity-70 ml-0"
                class:btn-disabled={$page === page_count - 1}
                on:click={nextPage}>»</button
            >
            <button
                class="btn opacity-70 btn-neutral flex-grow opacity-70 ml-0"
                on:click={togglePages}>{toggle_string}</button
            >
        </div>
        <div class="order-1 md:order-2 grow md:grow-0 self-stretch">
            <input
                bind:value={$filter_string}
                placeholder="ψάξε εδώ για όλα τα θέματα"
                class="w-full h-full p-1 opacity-70 bg-neutral text-primary-content border-2 border-neutral focus:border-2 focus:border-fuchsia-400 outline-none"
                type="search"
            />
        </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-2">
        {#each currently_shown as episode, i (i)}
            <EpisodeCard
                name={formatName(episode.title)}
                date={episode.publish_date}
                image_url={episode.image}
                number={episode.number}
                link={episode.link}
            />
        {/each}
    </div>
</div>

<style>
    .btn-group > .btn:not(:first-child) {
        margin-left: 0px;
    }
</style>
